import { useEffect } from "react";
import { PublicLayout } from "@/components/layout/PublicLayout";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { LEGAL } from "@/config/legal";

export default function CookiesPage() {
  useEffect(() => {
    document.title = "Cookie Policy | Decision Sales OS";
  }, []);

  return (
    <PublicLayout showCookieBanner={false}>
      <h1 className="text-3xl font-semibold tracking-tight mb-4">Cookie Policy</h1>
      <p className="text-muted-foreground mb-8">Last updated: February 2025</p>

      <Card className="mb-6">
        <CardHeader>
          <CardTitle>1. Introduction</CardTitle>
        </CardHeader>
        <CardContent className="prose prose-neutral dark:prose-invert max-w-none text-muted-foreground">
          <p>
            {LEGAL.companyName} uses cookies and similar technologies on this website.
            This policy explains what cookies we use and how you can manage your preferences.
          </p>
        </CardContent>
      </Card>

      <Card className="mb-6">
        <CardHeader>
          <CardTitle>2. Categories</CardTitle>
        </CardHeader>
        <CardContent className="prose prose-neutral dark:prose-invert max-w-none text-muted-foreground space-y-4">
          <p><strong>Essential:</strong> Required for the site to function (e.g. authentication, security). These cannot be disabled.</p>
          <p><strong>Analytics:</strong> Help us understand how visitors use the site (e.g. usage statistics).</p>
          <p><strong>Marketing:</strong> Used for advertising and campaign measurement, where applicable.</p>
        </CardContent>
      </Card>

      <Card className="mb-6">
        <CardHeader>
          <CardTitle>3. Your choices</CardTitle>
        </CardHeader>
        <CardContent className="prose prose-neutral dark:prose-invert max-w-none text-muted-foreground">
          <p>
            You can accept all, reject non-essential, or manage preferences at any time via the
            &quot;Cookie preferences&quot; link in the footer.
          </p>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle>4. Contact</CardTitle>
        </CardHeader>
        <CardContent className="prose prose-neutral dark:prose-invert max-w-none text-muted-foreground">
          <p>
            For questions about cookies, contact:{" "}
            <a href={`mailto:${LEGAL.dpoEmail}`} className="text-primary hover:underline">
              {LEGAL.dpoEmail}
            </a>
          </p>
        </CardContent>
      </Card>
    </PublicLayout>
  );
}
